import {
  createAsyncActionTypes,
  createActionTypes,
} from '../../util/createLifeomicActionTypes';

export default {
  ...createAsyncActionTypes([
    'FETCH_EDUCATION_CONTENT',
    'FETCH_EDUCATION_CONTENT_BY_ID',
    'CREATE_EDUCATION_CONTENT',
    'DELETE_EDUCATION_CONTENT',
    'UPDATE_EDUCATION_CONTENT',
    'UPDATE_EDUCATION_CONTENT_STATUS',
  ]),
  ...createActionTypes([
    'SET_SELECTED_CONTENT_TYPE_FILTER',
    'SET_SHOW_PENDING_CONTENT',
    'CHANGE_EDUCATION_CONTENT_IN_LIST',
  ]),
};
